module.exports = __webpack_public_path__ + "img/pic_01@2x.64640938.png";